import { THistoryFormData } from 'src/@types';
import { IHistory } from 'src/models';
import { TPageParams } from 'src/models/extensions/withPagination';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/history';

/**
 * 목록 조회
 */
export const getHistory = async (pageParams: TPageParams) => {
  try {
    const url = SUB_URL + objectToQueryString(pageParams);
    const response = await instance.get<TApiResponseData<IHistory[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 상세 조회
 */
export const getDetail = async (historySid: number) => {
  try {
    const url = `${SUB_URL}/${historySid}`;
    const response = await instance.get<TApiResponseData<IHistory>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 등록
 */
export const post = async (data: THistoryFormData) => {
  try {
    const url = `${SUB_URL}`;

    const response = await instance.post<TApiResponseData<IHistory>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 수정
 */
export const put = async (historySid: number, data: THistoryFormData) => {
  try {
    const url = `${SUB_URL}/${historySid}`;

    const response = await instance.put<TApiResponseData<IHistory>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 삭제
 */
export const remove = async (historySid: number) => {
  try {
    const url = `${SUB_URL}/${historySid}`;
    const response = await instance.delete<TApiResponseData<IHistory>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
